import api from '@/api/api'
import type { AxiosResponse } from 'axios'
import type { Industry } from '@/types/industry'
import type { CompanyIndustryOption, CompanyIndustryProfilesConfig } from '@/types/company'

export interface IndustryResponse {
  status: string
  data: Industry[]
}

export const getIndustries = (): Promise<AxiosResponse<IndustryResponse>> => {
  return api.get('/v2/industries', { role: 'company' })
}

export const getCompanyIndustryOptions = (): Promise<AxiosResponse<{ data: CompanyIndustryOption[] }>> => {
  return api.get('/v2/company-industry-options')
}

export const getCompanyIndustryProfiles = (): Promise<AxiosResponse<{ data: CompanyIndustryProfilesConfig }>> => {
  return api.get('/v2/company-industry-profiles')
}
